
import NoShowListItem from './components/NoShowListItem.vue'
import { NoContent, TitleAndEdit } from '../../../Common/CommonComponents'
export default {
    components: { NoShowListItem, NoContent, TitleAndEdit },
    data: () => ({
        loading: false,
    }),
    prop: {
        user: {}
    },
    methods: {
        switchComponent(appointment) {
            this.$router.push({name: 'Ikke møtt detaljer', params: {id: appointment.base64AppointmentId, siteId: appointment.siteId, order: appointment}})
        },
    },
    computed: {
        appointments() {
            return this.$store.getters['fairpay/getFairPayAppointments']
        }
    },
    async created() {
        await this.$store.dispatch('fairpay/getFairPayAppointmentDetails')
    }

}
